import { useEffect, useState } from "react";
import httpService from "../../services/httpService";

import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';

import PromptEditModal from "./PromptEditModal";

const PromptsTab = () => {
    const [prompts, setPrompts]       = useState([]);
    const [loading, setLoading]       = useState(true);
    const [error, setError]           = useState(null);
    const [selected, setSelected]     = useState(null);
    const [editedText, setEditedText] = useState('');
    const [saving, setSaving]         = useState(false);

    useEffect(() => {
        httpService.get('/admin/prompts')
            .then(res => setPrompts(res.data.data ?? []))
            .catch(err => setError(err.response?.data?.message || 'Failed to load prompts'))
            .finally(() => setLoading(false));
    }, []);

    const openEdit = (prompt) => { setSelected(prompt); setEditedText(prompt.prompt); };
    const closeEdit = () => { setSelected(null); setEditedText(''); };

    const handleSave = () => {
        setSaving(true);
        httpService.put(`/admin/prompts/${selected.type}`, { prompt: editedText })
            .then(res => {
                const updated = res.data.data;
                setPrompts(ps => ps.map(p => p.type === updated.type ? updated : p));
                closeEdit();
            })
            .catch(() => {})
            .finally(() => setSaving(false));
    };

    if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;
    if (error)   return <Alert variant="danger">{error}</Alert>;

    return (
        <>
            {prompts.length === 0 ? (
                <Alert variant="info">No prompts found. Run the PromptSeeder to populate.</Alert>
            ) : (
                <ListGroup>
                    {prompts.map(p => (
                        <ListGroup.Item key={p.type} className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                                <span className="fw-semibold font-monospace">{p.type}</span>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                                <small className="text-muted">Updated {new Date(p.updated_at).toLocaleString()}</small>
                                <Button size="sm" variant="outline-primary" onClick={() => openEdit(p)}>Edit</Button>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}

            <PromptEditModal
                prompt={selected}
                editedText={editedText}
                onChangeText={setEditedText}
                onSave={handleSave}
                onClose={closeEdit}
                saving={saving}
            />
        </>
    );
};

export default PromptsTab;
